import styled from '@emotion/styled';

export const SearchContainer = styled.div<any>`
  position: relative;
  ${(props) => !props.searchable && 'cursor: pointer;'}
  input {
    ${(props) => !props.searchable && 'cursor: pointer;'}
  }
  > div {
    ${(props) => props.autoHeight && 'max-height: fit-content; padding: 0.563em 6px;'}
  }
  > div {
    ${(props) => props.disabled && 'color: var(--color-smoke-70);'}
  }
  ${(props) => props.disabled && 'pointer-events: none;'}
`;

export const DroplistContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 999;
  padding-top: 8px;
`;

export const InputItem = styled.div`
  padding-left: 6px;
  font-size: 16px;
  line-height: 17px;
  display: flex;
  overflow: hidden;
  max-width: calc(100% - 20px);
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Loader = styled.div`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid #767676;
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: spin 0.6s linear infinite;
`;
